import { Component, computed, effect, input, ViewChildren } from '@angular/core';
import { InspectionFormWrapper } from '../inspection-form';
import {
  MultiAttachmentControlComponent,
} from '@shared/form-controls/attachment-upload/multi-attachment-control/multi-attachment-control.component';
import {
  SingleAttachmentControlComponent,
} from '@shared/form-controls/attachment-upload/single-attachment-control/single-attachment-control.component';
import { BehaviorSubject } from 'rxjs';
import { currentTenantId } from '@/utils/admin-utils';

@Component({
  standalone: false,
  selector: 'wr-detail-form',
  templateUrl: './detail-form.component.html',
  styleUrls: ['./detail-form.component.scss'],
})
export class DetailFormComponent {

  @ViewChildren(MultiAttachmentControlComponent)
  multiAttachmentControls!: MultiAttachmentControlComponent[];
  @ViewChildren(SingleAttachmentControlComponent)
  singleAttachmentControls!: SingleAttachmentControlComponent[];

  readonly currentTenantId = currentTenantId();

  readonly formWrapper = input.required<InspectionFormWrapper>();

  tenantFilter$ = new BehaviorSubject<string[]>([]);

  constructor() {
    effect(() => {
      const tenantId = this.currentTenantId();
      if (tenantId) {
        this.tenantFilter$.next([tenantId]);
      }
    });
  }

  readonly internalNumber = computed(() => this.formWrapper().value()?.building?.internalNumber ?? '');

  get hasAnyPendingAttachments(): boolean {
    return this.multiAttachmentControls.some(control => control.hasAnyPendingAttachments) ||
      this.singleAttachmentControls.some(control => control.loading$?.value);
  }
}
